import {gql} from '@apollo/client';

export const settingsMutations = {
    UPDATE_SETTINGS: gql`
        mutation UpdateSettings($input: SettingsUpdateRequestDTOInput!) {
            updateSettings(input: $input) {
                id
                tenantId
                title
                uniqueId
                objectId
                objectType
                value
                groupName
                controlType
                order
                status
                data {
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                dataType
            }
        }
    `,
    CREATE_SETTINGS: gql`
        mutation CreateSettings($input: SettingCreateRequestDTOInput!) {
            createSettings(input: $input) {
                id
                tenantId
                title
                uniqueId
                objectId
                objectType
                value
                groupName
                controlType
                order
                status
                data {
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                dataType
            }
        }
    `,
    CREATE_UPDATE_SETTINGS: gql`
        mutation CreateUpdateSettings($input: [SettingCreateUpdateRequestDTOInput!]!) {
            createUpdateSettings(input: $input) {
                id
                tenantId
                title
                uniqueId
                objectId
                objectType
                value
                groupName
                controlType
                order
                status
                data {
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                dataType
            }
        }
    `,
    REMOVE_SETTING: gql`
        mutation RemoveSetting($input: UUID!) {
            removeSetting(input: $input) {
                statusCode
                message
                data
            }
        }
    `,
};
